<template>
  <div class="create-project-container">
    <DialogSlot
      id="create-project-modal"
      ref="create-project-modal"
      :modalBtn="showCreateButtonName()"
      :modalHeader="modalHeaderText"
      :showCloseBtn="false"
      :beforeOpenModal="beforeOpenCreateProjectModal"
    >
      <div slot="content">
        <div>
          <input
            id="radio_po"
            v-model="numberType"
            type="radio"
            name="radio_po_contract"
            :value="PROJECT_TYPES.PO"
          >
          <label for="radio_po">{{ $t('project.type.po') }}</label>
          <input
            id="radio_contract"
            v-model="numberType"
            type="radio"
            name="radio_po_contract"
            :value="PROJECT_TYPES.CONTRACT"
          >
          <label for="radio_contract">{{ $t('project.type.contract') }}</label>
        </div>
        <span
          v-if="overAllError"
          class="error-hint"
        >
          {{ overAllError }}
        </span>
        <span
          v-if="overAllHint"
          class=""
        >
          {{ overAllHint }}
        </span>
        <div
          v-for="(_, index) of purchaseInputList"
          :key="index"
          class="number-info"
        >
          <div class="number-info__input">
            <input
              v-fusioninputcheck="fusionInputCheckOption"
              type="text"
              class="number-info__number"
              :placeholder="$t('tender.award.placeholder.number')"
              :value="purchaseInputList[index].number"
              :class="_errorHighLight(index)"
              required
              @change="event => inputValue(index, 'number', event.target.value)"
            >
            <input
              v-if="numberType === PROJECT_TYPES.CONTRACT"
              v-fusioninputcheck="fusionInputCheckOption"
              type="text"
              class="number-info__revision"
              :value="purchaseInputList[index].revisionNum"
              :placeholder="$t('tender.award.placeholder.revision')"
              :class="_errorHighLight(index)"
              required
              @change="event => inputValue(index, 'revisionNum', event.target.value)"
            >
            <HKLSelect
              v-if="numberType === PROJECT_TYPES.CONTRACT"
              :disabled="singleNumberInput && isTenderAward"
              class="small-2 medium-2 large-2 columns"
              :class="_errorHighLight(index)"
              :options="siteHklOptions"
              :placeholder="$t('tender.award.placeholder.siteId')"
              :showSearch="true"
              :value="purchaseInputList[index].siteId || undefined"
              required
              @change="val => purchaseInputList[index].siteId = val"
            />
            <div
              v-if="isTenderAward"
              class="number-info__btn"
            >
              <i
                v-if="!index"
                class="fa-plus fa"
                @click="() => addNumber()"
              />
              <i
                v-else
                class="fa-times fa"
                @click="() => removeNumber(index)"
              />
            </div>
          </div>
          <div class="number-info__hint">
            <span
              v-if="inputError[getErrorKeyFromIndex(index)]"
              class="error-hint"
            >
              {{ inputError[getErrorKeyFromIndex(index)] }}
            </span>
            <span
              v-else-if="errorMap[getErrorKeyFromIndex(index)]"
              class="error-hint"
            >
              {{ errorMap[getErrorKeyFromIndex(index)] }}
            </span>
          </div>
        </div>
      </div>
      <div slot="buttons">
        <button
          type="button"
          class="btn btn--darkblue"
          @click="closeProjectModal()"
        >
          {{ $t('action.cancel') }}
        </button>
        <button
          type="button"
          data-reveal-id="po-data-modal"
          class="btn btn--orange"
          @click="addNumbers"
        >
          {{ $t('action.continue') }}
        </button>
      </div>
    </DialogSlot>

    <DialogSlot
      id="po-data-modal"
      ref="po-data-modal"
      :modalHeader="$t('hint.whatWeFound')"
      :showCloseBtn="false"
    >
      <div slot="content">
        <div class="po-info-header-text">
          {{ companyName }}
        </div>
        <div class="po-info-text">
          {{ $t('project.purchaseOrder.totalAmount') }}: {{ totalAmount | formatCurrency({currencyCode}) }}
        </div>
        <PurchaseOrderPreview
          v-for="(purchaseOrder, index) in items"
          :key="index"
          :isTenderAward="isTenderAward"
          :type="numberType"
          :purchaseOrder="purchaseOrder"
          @createProject:updateAttachments="updateAttachments"
        />
      </div>
      <div slot="buttons">
        <button
          type="button"
          class="btn btn--darkblue"
          @click="goBackCreateProjectModal()"
        >
          {{ $t('action.goback') }}
        </button>
        <button
          v-if="isTenderAward"
          type="button"
          :disabled="!allowAwardTender"
          class="btn btn--orange"
          @click="awardTender()"
        >
          {{ $t('action.yesAward') }}
        </button>
        <button
          v-if="enableProjectFeature && !isTenderAward"
          type="button"
          class="btn btn--orange"
          @click="createProjectWithPoData()"
        >
          {{ $t('action.yesThatsit') }}
        </button>
      </div>
    </DialogSlot>

    <DialogSlot
      id="award-tender-success-modal"
      ref="award-tender-success-modal"
      :afterCloseModal="refreshTender"
      :showCloseBtn="false"
    >
      <div slot="content">
        <p :class="['content-text', 'font-bold']">
          <span>{{ $t('tender.awardSuccess') }}</span>
          <span v-if="showCreateProjectHint()">{{ $t('tender.createProjectHint') }}</span>
        </p>
      </div>
      <div
        v-if="showCreateProjectHint()"
        slot="buttons"
      >
        <button
          type="button"
          class="btn btn--darkblue"
          @click="closeAwardSuccessModal()"
        >
          {{ $t('action.notNow') }}
        </button>
        <button
          v-if="enableProjectFeature"
          type="button"
          class="btn btn--orange"
          @click="createProjectWithPoData()"
        >
          {{ $t('action.yesContinue') }}
        </button>
      </div>
      <div
        v-else
        slot="buttons"
      >
        <button
          type="button"
          class="btn btn--orange"
          @click="closeAwardSuccessModal()"
        >
          {{ $t('action.ok') }}
        </button>
      </div>
    </DialogSlot>
  </div>
</template>

<script>
import lodash from 'lodash'
import { mapActions, mapMutations, mapGetters } from 'vuex'
import HttpStatus from 'http-status-codes'
import DialogSlot from '@/controls/DialogSlot'
import PurchaseOrderPreview from '@/modules/projects/PurchaseOrderPreview'
import HKLSelect from '@/controls/Select/HKLSelect.vue'
import CmsModulesStatusMixin from '@/modules/CmsModulesStatusMixin'
import * as accountsRequest from '@/api/accounts/request'
import EventBus from '@/utils/eventBus'
import mutationTypes from '@/store/mutation-types'
import notification from '@/utils/notification'
import navigation from '@/utils/navigation'
import { aclHelper, aclPermsType } from '@/utils/aclHelper'
import { checkActiveProjectByNumber, getProjectMeta } from '@/api/projects/request'
import { getDepartmentByLocationCode, validateSite } from '@/api/locations/request'
import { getTender, checkPOAwarded, checkContractAwarded, checkSiteValidForContract } from '@/api/tenders/request'
import { EmailTypes, ActionTypes } from '@/utils/consts'
import { fusionInputCheckUtil } from '@/plugin/FusionInputCheck'
import { getBidById } from '@/api/bids/request'
import { sendEmail } from '@/api/postman/request'
import { tenderStatus } from '@/utils/locale'
import { getPurchaseNumber } from '@/api/projects/util'
import { createContract, createPurchaseOrder, getExternalContract, getExternalPO } from '@/api/purchases/request'
import { PO_MIN_LENGTH, PROJECT_TYPES } from './consts'

export default {
  name: 'CreateProject',
  components: {
    HKLSelect,
    PurchaseOrderPreview,
    DialogSlot,
  },
  mixins: [CmsModulesStatusMixin],
  props: {
    isTenderAward: {
      type: Boolean,
      default: false,
    },
    recommendedBidId: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      attachments: {},
      purchaseInputList: [{}],
      inputError: {},
      errorMap: {},
      overAllError: '',
      overAllHint: '',
      items: [],
      PROJECT_TYPES,
      numberType: PROJECT_TYPES.PO,
      fusionInputCheckOption: {type: 'string', required: true},
    }
  },
  computed: {
    ...mapGetters('tenders', {
      currentTender: 'currentTender',
    }),
    ...mapGetters('user', ['currentUser']),
    curTenderCurrencyCode () {
      return lodash.get(this.currentTender, 'purchaseRequisition.currencyCode')
    },
    companyName () {
      return lodash.get(this.items, '0.vendor.name', this.$t('emptyValue'))
    },
    totalAmount () {
      return lodash.sumBy(this.items, item => +item.amount)
    },
    currencyCode () {
      const currencyCodeMap = lodash.uniq(this.items.map(item => item.currencyCode))
      if (currencyCodeMap.length === 1) {
        return currencyCodeMap[0]
      }
      return this.$globalProps.getCurrency()
    },
    modalHeaderText () {
      const isSingleInput = !this.isTenderAward
      switch (this.numberType) {
        case PROJECT_TYPES.PO:
          return isSingleInput ? this.$t('hint.enterPONum.single') : this.$t('hint.enterPONum.plural')
        case PROJECT_TYPES.CONTRACT:
          return isSingleInput ? this.$t('hint.enterContractNum.single') : this.$t('hint.enterContractNum.plural')
        default:
          return ''
      }
    },
    allowAwardTender () {
      return this.attachments && this.items && this.items.every(purchaseItem => {
        const number = getPurchaseNumber(this.numberType, purchaseItem)
        const poAttachments = this.attachments[number]
        return poAttachments && poAttachments.length
      })
    },
    singleNumberInput () {
      return this.purchaseInputList.length === 1
    },
    messageType () {
      return this.numberType.toLowerCase()
    },
    siteOptions () {
      const siteCodes = (this.currentUser.locations || [])
        .map(item => item.code)
      return lodash.uniq(siteCodes)
    },
    siteHklOptions () {
      return this.siteOptions.map((code) => ({ name: code, value: code }))
    },
  },
  watch: {
    numberType () {
      this.resetPoData(false)
    },
  },
  methods: {
    ...mapActions('tenders', [
      'saveCurrentTender',
      'saveAnalysisReco',
      'updateTenderStatus',
      'refreshTender',
      'bindNumber',
    ]),
    ...mapMutations('tenders', {
      updateTenderPathField: mutationTypes.TENDER_UPDATE_PATH_FIELD,
    }),
    ...mapActions('projects', [
      'createProject',
    ]),
    getErrorKeyFromIndex (index) {
      return this.numberType === PROJECT_TYPES.PO
        ? this.purchaseInputList[index].number
        : `${this.purchaseInputList[index].number}-${this.purchaseInputList[index].revisionNum}`
    },
    getPOContractNumber (numberObject) {
      return getPurchaseNumber(this.numberType, numberObject)
    },
    _errorHighLight (index) {
      let errorKey = this.getErrorKeyFromIndex(index)
      return {
        'error-highlight': this.overAllError ||
          this.inputError[errorKey] ||
          this.errorMap[errorKey],
      }
    },
    async beforeOpenCreateProjectModal () {
      return this.startAward()
    },
    async startAward () {
      if (!this.isTenderAward) {
        this.openProjectModal()
        return true
      }

      if (!this.recommendedBidId) {
        notification.fireNotification(false, this.$i18n.t('tender.award.noRecommendedVendor'))
        return false
      }

      this.openProjectModal()
      return true
    },

    addNumber (isDefaultSite = false) {
      if (this.numberType === PROJECT_TYPES.CONTRACT) {
        this.purchaseInputList.push(this._createEmptyContractInput(isDefaultSite))
      } else {
        this.purchaseInputList.push({})
      }
    },

    inputValue (index, attr, val) {
      const oldErrorKey = this.getErrorKeyFromIndex(index)
      this.purchaseInputList[index][attr] = typeof val === 'string' ? val.trim() : val
      const errorKey = this.getErrorKeyFromIndex(index)
      this.$delete(this.inputError, oldErrorKey)
      this.$delete(this.errorMap, oldErrorKey)
      this.$delete(this.inputError, errorKey)
      this.$delete(this.errorMap, errorKey)
      this.overAllError = ''
      this.overAllHint = ''
      this.checkInputNumber()
    },

    removeNumber (index) {
      this.purchaseInputList.splice(index, 1)
      if (this.purchaseInputList.length === 1 &&
        this.numberType === PROJECT_TYPES.CONTRACT &&
        this.isTenderAward) {
        this.purchaseInputList[0].siteId = lodash.get(this.currentTender, 'purchaseRequisition.siteId', '')
      }
    },

    showCreateButtonName () {
      return (this.isTenderAward)
        ? this.$i18n.t('action.tenderAward')
        : this.$i18n.t('action.newProject')
    },

    openProjectModal () {
      this.resetPoData()
      this.$emit('close:awardModal')
    },
    closeProjectModal () {
      this.$refs['create-project-modal'].closeModal()
    },
    openPoModal () {
      this.$refs['po-data-modal'].openModal()
    },
    closePoModal () {
      this.$refs['po-data-modal'].closeModal()
    },
    goBackCreateProjectModal () {
      this.$refs['po-data-modal'].closeModal()
      this.$refs['create-project-modal'].openModal()
    },
    openAwardSuccessModal () {
      this.$refs['award-tender-success-modal'].openModal()
    },
    closeAwardSuccessModal () {
      this.$refs['award-tender-success-modal'].closeModal()
    },
    updateAttachments (poNumber, attachments) {
      this.$set(this.attachments, poNumber, attachments)
    },
    resetPoData (resetType = true) {
      this.errorMap = {}
      this.inputError = {}
      this.overAllError = ''
      this.overAllHint = ''
      this.items = []
      if (resetType) {
        this.numberType = PROJECT_TYPES.PO
      }
      this.purchaseInputList = []
      this.addNumber(true)
    },
    validateRequired () {
      fusionInputCheckUtil.validateAllFields({allowEmpty: 'none'}, '.number-info')
      const result = fusionInputCheckUtil.isAllFieldsValid('.number-info')
      return result
    },
    async validPoNumber (purchaseOrder, poInput) {
      const poNumber = poInput.number
      const errorKey = this.getPOContractNumber(poInput)
      if (!purchaseOrder) {
        this.$set(this.errorMap, errorKey, this.$i18n.t('error.po.400'))
        return false
      }
      try {
        const dept = await getDepartmentByLocationCode(purchaseOrder.siteId)
        if (!dept) {
          this.$set(this.errorMap, errorKey, this.$i18n.t('settings.site.noDeptSite'))
          return false
        }
        const isSiteValid = await validateSite(purchaseOrder.siteId)
        if (!isSiteValid) {
          this.$set(this.errorMap, errorKey, this.$i18n.t('error.po.notAllowed'))
          return false
        }

        if (this.isTenderAward) {
          const isPOAwarded = await checkPOAwarded(poNumber)
          if (isPOAwarded) {
            this.$set(this.errorMap, errorKey, this.$i18n.t('error.po.inUseByAward'))
            return false
          }
        } else {
          const hasActiveProject = await checkActiveProjectByNumber(purchaseOrder.number, this.numberType)
          if (hasActiveProject) {
            this.$set(this.errorMap, errorKey, this.$i18n.t('error.po.inUseByProject'))
            return false
          }
        }
      } catch (err) {
        console.error(err)
        this.$set(this.errorMap, errorKey, this.$i18n.t('error.system'))
        return false
      }
      return true
    },

    async validContractNumber (contract, contractNumber, contractRevision) {
      const errorKey = this.getPOContractNumber({ number: contractNumber, revisionNum: contractRevision })
      if (!contract) {
        this.$set(this.errorMap, errorKey, this.$i18n.t('error.contract.400'))
        return false
      }
      try {
        if (this.isTenderAward) {
          const isSiteValid = await validateSite(contract.siteId)
          if (!isSiteValid) {
            this.$set(this.errorMap, errorKey, this.$i18n.t('error.contract.invalidSite'))
            return false
          }
          const isContractAwarded = await checkContractAwarded(contractNumber, contractRevision)
          if (isContractAwarded) {
            this.$set(this.errorMap, errorKey, this.$i18n.t('error.contract.inUseByAward'))
            return false
          }
        } else {
          const hasActiveProject = await checkActiveProjectByNumber(contract.number, this.numberType, contractRevision)
          if (hasActiveProject) {
            this.$set(this.errorMap, errorKey, this.$i18n.t('error.contract.inUseByProject'))
            return false
          }

          const isSiteValidForContract = await checkSiteValidForContract(contract.siteId, contractNumber, contractRevision)
          if (!isSiteValidForContract) {
            this.$set(this.errorMap, errorKey, this.$i18n.t('error.contract.siteNotMatch'))
            return false
          }
        }
      } catch (err) {
        console.error(err)
        this.$set(this.errorMap, errorKey, this.$i18n.t('error.system'))
        return false
      }
      return true
    },

    checkInputNumber () {
      const countMap = lodash(this.purchaseInputList.filter(item =>
        this.numberType === PROJECT_TYPES.PO ? item.number : item.number && item.revisionNum)
        .map(item => this.getPOContractNumber(item)))
        .countBy()
        .value()
      let inputErrorMessageMap = {}
      Object.keys(countMap).forEach(key => {
        if (!!key && countMap[key] > 1) {
          inputErrorMessageMap[key] = this.$i18n.t(`error.${this.messageType}.409`)
        }
      })
      this.inputError = inputErrorMessageMap
    },

    checkTotalAmountAndCurrency (purchases, bidInfo) {
      const totalAmount = lodash.sumBy(purchases, purchaseOrder => +purchaseOrder.amount)
      const budget = bidInfo.totalFeeAdjusted ? bidInfo.totalFeeAdjusted : bidInfo.totalFee
      const isCurrencyNotSame = purchases.some(item => item.currencyCode !== this.curTenderCurrencyCode)
      const isSameBudget = Number(totalAmount) === Number(budget)
      if (!isSameBudget || isCurrencyNotSame) {
        if (this.numberType === PROJECT_TYPES.PO) { this.overAllError = this.$i18n.t('error.po.totalAmountNotMatched') } else { this.overAllError = this.$i18n.t('error.contract.totalAmountNotMatched') }
        if (isCurrencyNotSame) {
          const warningMsg = purchases.filter(item => item.currencyCode !== this.curTenderCurrencyCode).map(item => ({ [item.number]: item.currencyCode }))
          console.warn(`The Tender currency is ${this.curTenderCurrencyCode} that is diff with PO/Contract(${JSON.stringify(warningMsg)})`)
        }
        return false
      }
      return true
    },

    validatePurchaseForAwardTender (purchaseItem, vendorBidInfo, multiNumbers = false) {
      if ((!multiNumbers && (purchaseItem.siteId !== deep(this.currentTender, 'purchaseRequisition.siteId'))) ||
        (purchaseItem.vendor.id !== vendorBidInfo.bid.vendorId)) {
        let errorMessage
        if (this.numberType === PROJECT_TYPES.PO) {
          errorMessage = multiNumbers
            ? this.$t('error.po.tenderNotMatched') : this.$t('error.po.tenderOrSiteNotMatched')
        } else {
          errorMessage = this.$t('error.contract.tenderNotMatched')
        }
        this.$set(this.errorMap, this.getPOContractNumber(purchaseItem), errorMessage)
        return false
      }
      return true
    },

    async validatePurchaseForCreateProject (purchaseItem) {
      errorKey
      const errorKey = this.getPOContractNumber(purchaseItem)
      if (!deep(purchaseItem, 'vendor.id')) {
        this.$set(this.errorMap, errorKey, this.$i18n.t('hint.missingVendorOperation'))
        return false
      }
      const [vendorAccounts] = await accountsRequest.getAccountsAdmins({ id: purchaseItem.vendor.id })
      if (!vendorAccounts || vendorAccounts.length <= 0) {
        this.$set(this.errorMap, errorKey, this.$i18n.t('hint.missingVendorOperation'))
        return false
      }
      return true
    },

    async addNumbers () {
      if (!this.validateRequired()) {
        return
      }
      switch (this.numberType) {
        case PROJECT_TYPES.PO:
          return this.addPoNumbers()
        case PROJECT_TYPES.CONTRACT:
          return this.addContractNumbers()
      }
    },

    async addPoNumbers () {
      // Input Error Check
      if (Object.keys(this.inputError).length) {
        return false
      }

      // Clear All error hint objects
      this.errorMap = {}
      this.inputError = {}
      this.overAllError = ''
      this.overAllHint = ''

      // Exclude all the empty numbers, if no number left, return.
      const numbers = this.purchaseInputList.filter(poInput => !!poInput.number)
      if (numbers.length === 0) {
        return false
      }

      // Check if the bid content of vendorBid exist
      let vendorBidInfo
      if (this.isTenderAward) {
        vendorBidInfo = await getBidById(this.recommendedBidId)
        if (!lodash.get(vendorBidInfo, 'bid.content')) {
          this.overAllError = this.$i18n.t('error.po.bidEmpty')
          return false
        }
      }
      const isMultiPO = numbers.length > 1
      // Get all the Purchase Order from purchaseInputList.
      let poList = []
      for (let poInput of numbers) {
        const poNumber = poInput.number
        const errorKey = this.getPOContractNumber(poInput)
        if (poNumber.length <= PO_MIN_LENGTH) {
          this.$set(this.errorMap, errorKey, this.$t('error.po.400'))
          continue
        }
        let purchaseOrder
        try {
          purchaseOrder = await getExternalPO(poNumber)
        } catch (err) {
          console.error(err)
          this.$set(this.errorMap, errorKey, this.$t('error.po.404'))
          continue
        }

        // Check if the Purchase Order is valid
        // Step 1, check if the Purchase Order is basically valid
        const isPOValid = await this.validPoNumber(purchaseOrder, poInput)
        if (!isPOValid) {
          continue
        }
        // Step 2, check if the Purchase Order can be used in Awarding Tender/Creating Project
        const isValidForAwardCreate = this.isTenderAward
          ? this.validatePurchaseForAwardTender(purchaseOrder, vendorBidInfo, isMultiPO)
          : await this.validatePurchaseForCreateProject(purchaseOrder)
        if (isValidForAwardCreate) {
          purchaseOrder.amount = Number(purchaseOrder.amount)
          purchaseOrder.amountBase = Number(purchaseOrder.amountBase)
          poList.push(purchaseOrder)
        }
      }
      if (poList.length !== numbers.length) {
        return false
      }
      // Check if the total amount of purchaseOrder equals to the bid budget.
      if (this.isTenderAward && !this.checkTotalAmountAndCurrency(poList, lodash.get(vendorBidInfo, 'bid.content.service', {}))) {
        return false
      }
      try {
        if (this.isTenderAward) {
          await this.assignProjectMeta(poList, true)
        }
        this.items = poList

        this.errorMap = {}
        this.inputError = {}
        this.overAllError = ''
        this.overAllHint = ''
        this.closeProjectModal()
        this.openPoModal()
      } catch (err) {
        console.error(err)
        this.overAllError = this.$t('error.client')
        return false
      }
      return true
    },

    async addContractNumbers () {
      // Clear All error hint objects
      this.errorMap = {}
      this.inputError = {}
      this.overAllError = ''
      this.overAllHint = ''

      // Check if the bid content of vendorBid exist
      let vendorBidInfo
      if (this.isTenderAward) {
        vendorBidInfo = await getBidById(this.recommendedBidId)
        if (!lodash.get(vendorBidInfo, 'bid.content')) {
          this.overAllError = this.$i18n.t('error.contract.bidEmpty')
          return false
        }
      }
      const isMultiContract = this.purchaseInputList.length > 1
      // Get all the Contracts from purchaseInputList.
      let contractList = []
      for (let contractInput of this.purchaseInputList) {
        let contract
        const contractNumber = contractInput.number
        let contractRevision = contractInput.revisionNum
        const contractSiteId = contractInput.siteId
        let errorKey = this.getPOContractNumber(contractInput)
        try {
          contract = await getExternalContract(contractNumber, contractRevision)
        } catch (err) {
          console.error(err)
          this.$set(this.errorMap, errorKey, this.$t('error.contract.404'))
          continue
        }
        if (contract.siteId) {
          if (contractInput.siteId !== contract.siteId && this.isTenderAward) {
            this.inputError = { ...this.inputError, [errorKey]: this.$t('error.contract.siteNotMatchProject') }
            this.overAllHint = this.$t('hint.contractSiteInvalid')
            continue
          }
        } else {
          contract.siteId = contractSiteId
        }
        // Check if the Contract is valid
        // Step 1, check if the Contract is basically valid
        const isContractValid = await this.validContractNumber(contract, contractNumber, contractRevision)
        if (!isContractValid) {
          continue
        }
        // Step 2, check if the Contract can be used in Awarding Tender/Creating Project
        const isValidForAwardCreate = this.isTenderAward
          ? this.validatePurchaseForAwardTender(contract, vendorBidInfo, isMultiContract)
          : await this.validatePurchaseForCreateProject(contract)
        if (isValidForAwardCreate) {
          contractList.push(contract)
        }
      }
      if (contractList.length !== this.purchaseInputList.length) {
        return false
      }
      // Check if the total amount of contracts equals to the bid budget.
      if (this.isTenderAward && !this.checkTotalAmountAndCurrency(contractList, lodash.get(vendorBidInfo, 'bid.content.service', {}))) {
        return false
      }
      if (this.isTenderAward) {
        await this.assignProjectMeta(contractList)
      }
      this.items = contractList
      this.errorMap = {}
      this.inputError = {}
      this.overAllError = ''
      this.closeProjectModal()
      this.openPoModal()
    },

    async assignProjectMeta (items, isPo) {
      const numbers = items.map(item => { return {number: item.number, revisionNum: item.revisionNum} })
      const projectMetaData = await getProjectMeta(numbers, isPo)
      items.forEach((item, i) => {
        item.poResourceId = projectMetaData[i].poAttachmentId
        item.inviteDate = projectMetaData[i].inviteDate
        item.isProjectExists = projectMetaData[i].isProjectExists
      })
    },

    async createProjectWithPoData () {
      if (!this.enableProjectFeature) return
      let tenderId = this.currentTender.general.id
      if (this.isTenderAward) {
        if (!this.checkIfBindSucceed()) {
          let response = {
            status: HttpStatus.REQUEST_TIMEOUT,
          }
          notification.handleResponseAlert(response, 'createProject', null, true)
          return
        }
        this.closeAwardSuccessModal()
      }
      this.closePoModal()
      if (!this.items || !this.items.length) {
        return
      }
      await Promise.all(this.items.map(async item => {
        try {
          if (this.isTenderAward && item.isProjectExists) return true
          let request = {
            poAttachmentId: item.poResourceId,
          }
          if (this.numberType === PROJECT_TYPES.PO) {
            request.purchaseOrder = item
          } else {
            request.contract = item
          }
          if (!this.isTenderAward && this.items.length === 1) {
            request.navToPage = 'projectDetail'
          }
          request.tenderId = tenderId
          await this.createProject(request)
          return true
        } catch (err) {
          console.error(err)
          return false
        }
      }))
      this.resetPoData()
      if (this.isTenderAward) {
        await this.refreshTender()
        navigation.toHome()
      }
    },
    async awardTender () {
      if (this.items && this.items.every(item => item.vendor)) {
        const createResults = await Promise.all(this.items.map(async item => {
          try {
            if (this.numberType === PROJECT_TYPES.PO) {
              await createPurchaseOrder(item)
            } else {
              await createContract(item)
            }
            return true
          } catch (err) {
            console.error(err)
            return false
          }
        }))
        if (!createResults.every(result => result)) {
          this.overAllError = this.$t('error.client')
          this.goBackCreateProjectModal()
          return
        }
        this.$root.$children[0].$refs.loadingLayer.$emit('startLoading')

        const numbers = this.items.map(item => this.getPOContractNumber(item))

        this.updateTenderPathField({
          path: ['general', 'numbers'],
          newValue: numbers,
        })
        let poResourceIds = {}
        let resourceMap = {}
        this.items.forEach(item => {
          let key = this.getPOContractNumber(item)
          poResourceIds[key] = item.poResourceId
          resourceMap[key] = {
            number: item.number,
            revisionNum: item.revisionNum,
            resourceId: item.poResourceId,
          }
        })
        await this.bindNumber({
          tenderId: this.currentTender.general.id,
          resourceMap: resourceMap,
          type: this.numberType,
        })
        this.updateTenderPathField({
          path: ['general', 'awardedDate'],
          newValue: new Date(Date.now()),
        })
        this.updateTenderPathField({
          path: ['general', 'numberType'],
          newValue: this.numberType,
        })
        this.updateTenderPathField({
          path: ['general', 'analysis', 'data', 'poResourceIds'],
          newValue: poResourceIds,
        })

        await this.saveAnalysisReco()
        await this.saveCurrentTender({ showNotification: false, updatedBidStatus: false })
        await this.updateTenderStatus({
          id: this.currentTender.general.id,
          status: tenderStatus.AWARDED,
          action: ActionTypes.tenders.award,
        })
        const docIds = lodash.flatMap(this.items, item => {
          const number = getPurchaseNumber(this.numberType, item)
          return (this.attachments[number] || []).map(attachment => attachment.id) || []
        })
        sendEmail(EmailTypes.tenders.awardVendor, {
          awardedId: this.recommendedBidId,
          docIds,
        })
        this.$root.$children[0].$refs.loadingLayer.$emit('stopLoading')
        this.closePoModal()
        this.openAwardSuccessModal()
        EventBus.$emit('modules_tender_refresh_pofiles')
      }
    },
    async checkIfBindSucceed () {
      let tender = await getTender(this.currentTender.general.id)
      if (tender.general.contracts.length > 0 || tender.general.purchaseOrders.length > 0) {
        return true
      }
      return false
    },
    showCreateProjectHint () {
      return this.enableProjectFeature && aclHelper.getAccess(aclPermsType.projects.manage) && this.items.some(item => !item.isProjectExists)
    },
    _createEmptyContractInput (isDefaultSite = true) {
      const defaultSiteId = isDefaultSite
        ? lodash.get(this.currentTender, 'purchaseRequisition.siteId', '')
        : ''
      return {
        number: '',
        revision: '',
        siteId: defaultSiteId,
      }
    },
  },
}
</script>

<style lang='scss'>
#award-tender-success-modal {
  p.content-text {
    font-family: Verdana;
  }
}

#po-data-modal {
  .modal.small-modal {
    width: 750px
  }
}
</style>

<style lang="scss" scoped>
@import '~styles/common';
@import '~styles/project/style';

.number-info-text {
  width: 100%;
}

.number-info__input {
  display: flex;
  width: 100%;
  .number-info__btn {
    width: 5%;
    margin: 10px;
    i.fa {
      font-size: 20px;
    }
  }
  input[type='text'] {
    margin-right: 5px;
    width: 100%;
  }
  .number-info__number {
    min-width: 50%;
  }
}

.number-info__hint {
  padding-bottom: 5px;
}
.number-info__revision {
  flex: 0 0 18%;
}

.modal-header {
  font-family: Georgia;
  font-size: 18px;
  font-style: italic;
  text-align: left;
  color: #0c3a58;
}

button:disabled {
  background-color: #d3d3d3;
  color: #fff;
  border-bottom: solid 2px #c5c5c5;
}

button {
  cursor: pointer;
}

.error-hint-detail {
  margin: 10px 0;
  display: block;
}

</style>
